"use client";

import { c as _c } from "react/compiler-runtime";
import { NavItem } from "@/sanity/sanity.types";
import { useEffect, useRef, useState } from "react";
import { usePathname } from "next/navigation";
import SubMenuContent from "@/components/common/header/header-menu/sub-menu-content/sub-menu-content";
import HomeNavigationItemWithSubnavigationButton from "./home-navigation-item-with-subnavigation-button";
export interface HomeNavigationItemWithSubnavigationRef {
  setExpanded: (expanded: boolean) => void;
}
interface HomeNavigationItemWithSubnavigationProps {
  data: {
    _key: string;
  } & NavItem;
  onOpen?: (ref: HomeNavigationItemWithSubnavigationRef) => void;
  onClose?: (ref: HomeNavigationItemWithSubnavigationRef) => void;
}
const HomeNavigationItemWithSubnavigation = props => {
  const $ = _c(32);
  const {
    data,
    onOpen,
    onClose
  } = props;
  const {
    link,
    children
  } = data;
  const pathName = usePathname();
  const [expanded, setExpanded] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      setExpanded
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const selfRef = useRef(t0);
  const closeTimeoutRef = useRef(null);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setExpanded(true);
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleMouseEnter = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      setExpanded(false);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleMouseLeave = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
      closeTimeoutRef.current = setTimeout(() => {
        setExpanded(false);
      }, 500);
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleMouseMove = t3;
  let t4;
  if ($[4] !== onClose) {
    t4 = () => {
      setExpanded(false);
      onClose?.(selfRef.current);
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
      }
    };
    $[4] = onClose;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const cleanUp = t4;
  let t5;
  let t6;
  if ($[6] !== expanded || $[7] !== onClose || $[8] !== onOpen) {
    t5 = () => {
      if (expanded && onOpen) {
        onOpen(selfRef.current);
      } else {
        if (!expanded && onClose) {
          onClose(selfRef.current);
        }
      }
    };
    t6 = [expanded, onOpen, onClose];
    $[6] = expanded;
    $[7] = onClose;
    $[8] = onOpen;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  let t7;
  if ($[11] !== cleanUp) {
    t7 = () => {
      cleanUp();
    };
    $[11] = cleanUp;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== pathName) {
    t8 = [pathName];
    $[13] = pathName;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  useEffect(t7, t8);
  let t9;
  if ($[15] !== cleanUp) {
    t9 = () => () => {
      cleanUp();
    };
    $[15] = cleanUp;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [];
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  useEffect(t9, t10);
  if (!link || !children || children.length === 0) {
    return null;
  }
  let t11;
  if ($[18] !== link) {
    t11 = <HomeNavigationItemWithSubnavigationButton link={link} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseMove} />;
    $[18] = link;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = `absolute left-0 top-[72px] rounded-lg bg-white p-6 text-[#373B37] shadow-[0_10px_20px_0_rgba(0,0,0,0.04)] transition-opacity duration-300 ${expanded ? "opacity-100" : "pointer-events-none opacity-0"}`;
  let t13;
  if ($[20] !== expanded) {
    t13 = expanded ? () => closeTimeoutRef.current && clearTimeout(closeTimeoutRef.current) : undefined;
    $[20] = expanded;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  const t14 = expanded ? handleMouseLeave : undefined;
  let t15;
  if ($[22] !== data) {
    t15 = <SubMenuContent subMenuActive={data} linksPerColumn={5} />;
    $[22] = data;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== t12 || $[25] !== t13 || $[26] !== t14 || $[27] !== t15) {
    t16 = <div className={t12} onMouseEnter={t13} onMouseLeave={t14}>{t15}</div>;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t11 || $[30] !== t16) {
    t17 = <div className="z-[100]">{t11}{t16}</div>;
    $[29] = t11;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  return t17;
};
export default HomeNavigationItemWithSubnavigation;